module.exports = __webpack_public_path__ + "assets/d379fbc39518bf94983b2b819f775b24.mp3";